import Menu from "../menu/PublicMenu.jsx";
import Footer from "../footer/Footer.jsx";
import amplifyOutputs from "../../amplify_outputs.json";

const bucket = amplifyOutputs.storage.bucket_name;
const region = amplifyOutputs.storage.aws_region;

const columns = [
  {
    title: "Solutions",
    items: [
      { label: "Marketing", href: "/marketing" },
      { label: "Analytics", href: "/analytics" },
      { label: "Automation", href: "/automation" },
      { label: "Commerce", href: "/commerce" },
      { label: "Insights", href: "/insights" },
    ],
  },
  {
    title: "Support",
    items: [
      { label: "Submit ticket", href: "/ticket" },
      { label: "Documentation", href: "/documentation" },
      { label: "Guides", href: "/guides" },
    ],
  },
  {
    title: "Company",
    items: [
      { label: "About", href: "/about" },
      { label: "Blog", href: "/blog" },
      { label: "Jobs", href: "/jobs" },
      { label: "Press", href: "/press" },
    ],
  },
  {
    title: "Legal",
    items: [
      { label: "Terms of service", href: "/terms" },
      { label: "Privacy policy", href: "/privacy" },
      { label: "License", href: "/license" },
    ],
  },
];

const PublicLayout = ({ children }) => {
  return (
    <>
      <Menu />
      <div className="content">{children}</div>
      <Footer
        logo={`https://${bucket}.s3.${region}.amazonaws.com/publico/Fundadora.JPG`}
        description="R.M María Magdalena de la Reparación Vargas Galeana"
        //socialLinks={socialLinks}
        columns={columns}
        copyrightText="© 2024 Familia de Corde Jesu. Todos los derechos reservados."
      />
    </>
  );
};

export default PublicLayout;
